import { useMemo, useState, useEffect, useRef } from "react";
import { Modal } from "react-bootstrap";
import "./UserDetails.css";
import CommonTable from "../../components/CommonTable/CommonTable";
import PageHeader from "../../components/PageHeader/PageHeader";
import { useNavigate, useLocation } from "react-router-dom";
import moment from "moment";
import { FaTimes } from "react-icons/fa";
import { get, post } from "../../Services/ApiHandler";
import { URLS } from "../../Services/Constant";

const UserDetails = () => {
  const [activeTab, setActiveTab] = useState("booking");
  const tabRef = useRef(1);
  const navigate = useNavigate();
  const location = useLocation();
  const statePage = location?.state?.page;
  const page = statePage || 1;
  const id =
    location?.state?.id ||
    location?.state?.data?.id || null;
  const [showFssaiModal, setShowFssaiModal] = useState(false);

  const [data, setData] = useState(null);

  console.log("data-=====>", data);

  const userData = useMemo(
    () => ({
      name: data?.name || "",
      created_at: data?.created_at || "",
      mob_no: data?.mob_no || "",
      avg_rating: data?.avg_rating || 0,
      email: data?.email || "",
      profile_img_url: data?.profile_img_url || "",
      fssai_certificate_url: data?.fssai_certificate_url || "",
      overall_earnings: data?.overall_earnings || 0,
      user_type: data?.user_type || "-",
    }),
    [data]
  );

  const [bookingData, setBookingData] = useState([]);
  const [sellingData, setSellingData] = useState([]);

  //Table states
  const [pageNo, setPageNo] = useState(1);
  const [totalCount, setTotalCount] = useState();
  const [pagination, setPagination] = useState(null);
  const [searchText, setSearchText] = useState("");
  const pageRef = useRef(pageNo);
  const preSearchPageRef = useRef(pageNo);

  const bookingColumns = useMemo(
    () => [
      {
        Header: "S.No",
        accessor: (row, index) => String((index || 0) + 1).padStart(2, "0"),
        width: "5%",
      },
      {
        Header: "Order ID",
        accessor: "order_id",
        Cell: ({ value }) => value || "N/A",
      },
      {
        Header: "Seller Name",
        accessor: "seller_name",
        Cell: ({ value }) => value || "N/A",
      },
      {
        Header: "Food Name",
        accessor: "food_name",
        Cell: ({ value }) => value || "N/A",
      },
      {
        Header: "Quantity",
        accessor: "quantity_display",
        Cell: ({ value }) => value || 0,
      },
      {
        Header: "Qty Price",
        accessor: "amount",
        Cell: ({ value }) => `₹${value || 0}`,
      },
      {
        Header: "Date & Time",
        accessor: "date_time",
        Cell: ({ value }) => value ?? "N/A",
      },
      {
        Header: "Status",
        accessor: "status",
        Cell: ({ value }) => (
          <span
            className={`status-badge status-${value?.toLowerCase() || "unknown"
              }`}
          >
            {value || "Unknown"}
          </span>
        ),
      },
    ],
    [],
  );

  const sellingColumns = useMemo(
    () => [
      {
        Header: "S.No",
        accessor: (row, index) => String((index || 0) + 1).padStart(2, "0"),
        width: "5%",
      },
      {
        Header: "Order ID",
        accessor: "order_id",
        Cell: ({ value }) => value || "N/A",
      },
      {
        Header: "Buyer Name",
        accessor: "buyer_name",
        Cell: ({ value }) => value || "N/A",
      },
      {
        Header: "Food Name",
        accessor: "food_name",
        Cell: ({ value }) => value || "N/A",
      },
      {
        Header: "Quantity",
        accessor: "quantity_display",
        Cell: ({ value }) => value || 0,
      },
      {
        Header: "Qty Price",
        accessor: "amount",
        Cell: ({ value }) => `₹${value || 0}`,
      },
      {
        Header: "Date & Time",
        accessor: "date_time",
        Cell: ({ value }) => value ?? "N/A",
      },
      {
        Header: "Status",
        accessor: "status",
        Cell: ({ value }) => (
          <span
            className={`status-badge status-${value?.toLowerCase() || "unknown"
              }`}
          >
            {value || "Unknown"}
          </span>
        ),
      },
    ],
    [],
  );

  console.log("dataUserDetails", data);
  console.log(
    "22-data-=====>",
    data,
    page,
    pageNo,
    location?.state?.page,
    preSearchPageRef.current,
  );

  useEffect(() => {
    const fetchUserDetails = async () => {
      if (!id) return;
      try {
        const res = await get(`${URLS.USERLIST}${id}/`);
        console.log("User BYID res:", res);
        if (res?.status === "success") {
          setData(res?.user);
        }
      } catch (error) {
        console.error("Error fetching user details:", error);
      }
    };

    fetchUserDetails();
  }, [id]);
  const fetchData = async () => {
    let user_id = localStorage.getItem("user_id");
    let payload = {
      user_id: user_id,
      type: tabRef.current == 1 ? "booking" : "selling",
      // page: pageNo,
      search: searchText,
    };
    let url = `${URLS.USERS_ORDERS_LIST}?page=${pageNo}`;
    let res = await post(url, payload);
    if (res?.status == "success") {
      setTotalCount(res?.count || 0);
      if (tabRef.current == 1) {
        setBookingData(res?.data || []);
      } else {
        setSellingData(res?.data || []);
      }

      setPagination({
        current_page: res?.current_page || 1,
        last_page: res?.total_pages || 1,
      });
    }
  };

  console.log("page======>", page);

  useEffect(() => {
    if (data?.id) {
      localStorage.setItem("user_id", data.id);
    }
  }, [data]);

  useEffect(() => {
    pageRef.current = pageNo;
  }, [pageNo]);

  useEffect(() => {
    if (location?.state?.page) {
      // clear state after using it
      navigate(location.pathname, {
        replace: true,
        state: {
          page: page,
        },
      });
    }
  }, []);

  useEffect(() => {
    fetchData();
  }, [pageNo, searchText, activeTab]);

  const handleClearSearch = () => {
    setSearchText("");
    setPageNo(preSearchPageRef.current || 1);
  };
  console.log("userDatauserDatauserData", userData);

  return (
    <div className="user-details-container">
      <PageHeader
        title="User Details"
        showBackButton={true}
        onBackClick={() => navigate("/users", { state: { page: page || 1 } })}
      />

      <div className="profile-header-card">
        <div className="profile-image-wrapper">
          <img
            src={
              userData?.profile_img_url ||
              "https://images.unsplash.com/photo-1539571696357-5a69c17a67c6?q=80&w=1887&auto=format&fit=crop"
            }
            alt="Profile"
          />
        </div>
        <div className="profile-info-main">
          <h2>{userData?.name || "N/A"}</h2>
          <p>
            {userData?.user_type !== "Charitable Trust" && "Seller & Buyer |"}
            {userData?.fssai_certificate_url ? (
              <span
                onClick={() => setShowFssaiModal(true)}
                style={{
                  color: "#7a52ab",
                  textDecoration: "underline",
                  cursor: "pointer",
                }}
              >
                {userData?.user_type !== "Charitable Trust"
                  ? "fssai certified"
                  : "Deeb Certificate"}{" "}
              </span>
            ) : (
              <span>not certified</span>
            )}
          </p>
          <p>User Type : {userData?.user_type || "-"}</p>
        </div>
        <div className="profile-divider"></div>
        <div className="profile-details-grid">
          <div className="detail-item">
            <span className="detail-label">Register Date :</span>
            <span className="detail-value">
              {userData?.created_at
                ? new Date(userData.created_at).toLocaleDateString("en-GB")
                : "N/A"}
            </span>
          </div>
          {/* <div className="detail-item">
            <span className="detail-label">Email ID :</span>
            <span className="detail-value email">
              {userData?.email || "N/A"}
            </span>
          </div> */}
          <div className="detail-item">
            <span className="detail-label">Ratings :</span>
            <span className="detail-value">{userData?.avg_rating || 0}</span>
          </div>
          <div className="detail-item">
            <span className="detail-label">Mobile No :</span>
            <span className="detail-value">
              {userData?.mob_no ? `+91-${userData?.mob_no}` : "N/A"}
            </span>
          </div>
        </div>
      </div>

      <div className="user-details-tabs">
        <button
          className={`tab-btn ${activeTab === "booking" ? "active" : "inactive"
            }`}
          onClick={() => {
            setActiveTab("booking");
            tabRef.current = 1;
          }}
        >
          Booking Details
        </button>
        <button
          className={`tab-btn ${activeTab === "selling" ? "active" : "inactive"
            }`}
          onClick={() => {
            setActiveTab("selling");
            tabRef.current = 2;
          }}
        >
          Selling Details
        </button>
      </div>

      <div className="header-row">
        <h2 className="total-count">Total: {totalCount || 0}</h2>

        <div className="search-wrapper">
          <input
            type="text"
            placeholder="Search"
            className="search-input"
            value={searchText || ""}
            onChange={(e) => {
              const val = e.target.value;

              if (!searchText && val) {
                preSearchPageRef.current = pageNo || 1;
                setPageNo(1);
              } else if (searchText && !val) {
                setPageNo(preSearchPageRef.current || 1);
              }

              setSearchText(val);
            }}
          />
          {searchText && (
            <FaTimes
              className="search-clear-icon"
              onClick={handleClearSearch}
            />
          )}
        </div>
      </div>

      <div className="table-section">
        <CommonTable
          columns={activeTab === "booking" ? bookingColumns : sellingColumns}
          data={(activeTab === "booking" ? bookingData : sellingData) || []}
          pagecount={pagination}
          pageno={pageNo}
          setPageno={setPageNo}
        />
      </div>

      {/* FSSAI Certificate Modal */}
      <Modal
        show={showFssaiModal}
        onHide={() => setShowFssaiModal(false)}
        centered
        size="lg"
      >
        <Modal.Header
          closeButton
          className="d-flex justify-content-between align-items-center"
        >
          <Modal.Title style={{ color: "#7a52ab", fontWeight: "600" }}>
            FSSAI Certificate
          </Modal.Title>
          {/* {userData?.fssai_certificate_url && (
            <button
              onClick={handleDownload}
              className="btn-download"
              style={{
                marginRight: "40px",
                background: "none",
                border: "none",
                color: "#7a52ab",
                fontSize: "20px",
                cursor: "pointer",
              }}
              title="Download Certificate"
            >
              <FaDownload />
            </button>
          )} */}
        </Modal.Header>
        <Modal.Body className="text-center p-0" style={{ height: "80vh" }}>
          {userData?.fssai_certificate_url ? (
            userData.fssai_certificate_url.toLowerCase().endsWith(".pdf") ? (
              <iframe
                src={`${userData.fssai_certificate_url}#toolbar=0`}
                title="FSSAI Certificate PDF"
                width="100%"
                height="100%"
                style={{ border: "none", borderRadius: "0 0 8px 8px" }}
              />
            ) : (
              <div className="p-4">
                <img
                  src={userData.fssai_certificate_url}
                  alt="FSSAI Certificate"
                  style={{
                    maxWidth: "100%",
                    maxHeight: "70vh",
                    borderRadius: "8px",
                    boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                  }}
                />
              </div>
            )
          ) : (
            <div className="p-4">
              <p>No certificate available</p>
            </div>
          )}
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default UserDetails;
